import { render, staticRenderFns } from "./CategoryChoosePanel.vue?vue&type=template&id=ec8bf16e&scoped=true"
import script from "./CategoryChoosePanel.vue?vue&type=script&lang=js"
export * from "./CategoryChoosePanel.vue?vue&type=script&lang=js"
import style0 from "./CategoryChoosePanel.vue?vue&type=style&index=0&id=ec8bf16e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8bf16e",
  null
  
)

export default component.exports